import React, { useState, useEffect } from "react"
import { useGlobalFilter, usePagination, useSortBy, useTable, } from "react-table";
import { Button, Card, Col, Pagination, Row } from "react-bootstrap";
import BTable from "react-bootstrap/Table";

import "../../assets/stlyes/SuperAdmin/superAdminTab.scss"

import { SAAction, AddSchoolModal, SuperAdminColumns, styles, tableSizeP } from "./";
import { isEmptyArray, isEmptyObject } from "../../util";
import { Accessors, Common, GlobalFilter } from "../../helper";
import { LoadingSpinner } from "../Shared";

const Table = (props) => {
  const { columns, data, getSchoolDetails } = props;
  const [showModal, setShowModal] = useState()
  const { getTableProps, getTableBodyProps, headerGroups, globalFilter, setGlobalFilter, prepareRow, page, canPreviousPage, canNextPage, pageOptions, pageCount, gotoPage, nextPage, previousPage, setPageSize, state: { pageIndex, pageSize }, } = useTable({ columns, data, initialState: { pageIndex: 0, pageSize: 10 }, }, useGlobalFilter, useSortBy, usePagination);
  const OpenAddSchoolModal = () => { setShowModal(true) }

  return (
    <React.Fragment>
      <Row className="mb-3">
        <Col className="d-flex justify-content-start">
          <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} searchBy={"Search by SchoolName"} />
        </Col>
        <Col xs={3}>
          <div style={styles.addButton}>
            <Button style={{ background: "#084059", borderRadius: "25px", width: "150px", color: "white", zIndex: "1" }} onClick={OpenAddSchoolModal} >{"Add School"}</Button>
            <AddSchoolModal showModal={showModal} setShowModal={setShowModal} isEdit={false} formValues={""} getSchoolDetails={getSchoolDetails} />
          </div>
        </Col>
        <Col xs={8}></Col>
      </Row>
      <BTable striped bordered hover responsive  {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup,i) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={i}>
              {headerGroup.headers.map((column,j) => (
                <th {...column.getHeaderProps()} key={j}>
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={i}>
                {row.cells.map((cell,i) => {
                  return (
                    <td {...cell.getCellProps()} key={i}>
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </BTable>

      <div className="d-flex justify-content-end" style={styles.paginate}>
        <span className="d-flex align-items-baseline">
          {Common.RowsPerPage}
          <select
            className="form-control w-auto mx-2"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[5, 10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </span>
        <span
          className="d-flex align-items-center"
          style={{ marginBottom: "13px" }}
        >
          {Common.Page}{" "}
          <strong>
            {" "}
            {pageIndex + 1} of {pageOptions.length}{" "}
          </strong>{" "}
        </span>

        <Pagination className="justify-content-end">
          <Pagination.First
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
          />
          <Pagination.Prev
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          />
          <Pagination.Next
            onClick={() => nextPage()}
            disabled={!canNextPage}
          />
          <Pagination.Last
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          />
        </Pagination>
      </div>
    </React.Fragment>
  );
};

const SuperAdminTable = (props) => {
  const { setFullScreen, allSchoolData, getSchoolDetails } = props
  const [schoolData, setSchoolData] = useState();
  const columns = React.useMemo(() => SuperAdminColumns, []);
  const [isLoading, setIsLoading] = useState(false);

  const getData = async () => {
    setIsLoading(true);
    if (!isEmptyArray(allSchoolData.schools)) {
      let responseData = allSchoolData.schools;
      var finalData = [];
      for (let i = 0; i < responseData.length; i++) {
        responseData[i][Accessors.Action] = (
          responseData[i] && <SAAction schoolActionData={responseData[i]} getSchoolDetails={getSchoolDetails} activeStatus={responseData[i]["active"]} />
        );
        responseData[i][Accessors.Name] = responseData[i].name;
        responseData[i][Accessors.ContactName] = responseData[i].billingDetails?.firstName + " " + responseData[i].billingDetails?.lastName;
        responseData[i][Accessors.Active] = (
          <span style={{ width: "150px" }}>
            {responseData[i][Accessors.Active] ? <span>True</span> : <span>False</span>}
          </span>
        );
        responseData[i][Accessors.Country] = (
          <span style={{ width: "100px" }}>
            {/* {responseData[i]["address"][Accessors.Country]} */}
            {responseData[i]?.address?.country}
          </span>
        );
        responseData[i][Accessors.PostalCode] = responseData[i]?.address?.postCode;
        responseData[i][Accessors.Addresss] = responseData[i]?.address?.postalAddress + ", " + responseData[i]?.address?.city + ", " + responseData[i]?.address?.country + ", " + responseData[i]?.address?.postCode;
        responseData[i][Accessors.City] = responseData[i]?.address?.city;
        responseData[i][Accessors.Email] = responseData[i]?.billingDetails?.email;
        responseData[i][Accessors.UserCount] = (
          <span >
            {responseData[i][Accessors.UserCount]}
          </span >
        );
        finalData.push(responseData[i]);
      }
      setSchoolData(finalData);
    } else {
      setSchoolData({});
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, [allSchoolData]);

  return (
    <React.Fragment>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {!isEmptyObject(schoolData && schoolData) ? (
            <Row style={{ paddingRight: setFullScreen() }}>
              <Col sm={tableSizeP}>
                <Card>
                  <Card.Body>
                    {schoolData && (<Table columns={columns} data={schoolData && schoolData} getSchoolDetails={getSchoolDetails}/>)}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          ) : (
            <div className="d-flex justify-content-center">
              <h1>{Common.NoSchoolFound}</h1>
            </div>
          )}
        </>
      )}
    </React.Fragment>
  )
};
export { SuperAdminTable }
